export default __webpack_public_path__ + "static/media/worker4.f398b890.jpg";